import { useEffect, useState } from 'react'
import { Link } from 'react-router'
import { Preferences } from '@capacitor/preferences'
import { Wallet, TrendingUp, User, Upload } from 'lucide-react'
import { useAuth } from '../auth/AuthProvider'
import { FLAVOR } from '../flavor/flavor'
import styles from './SectionPage.module.css'

const INTRO_KEY = 'pfh.dashboardIntroDismissed'

export function DashboardPage() {
  const { user } = useAuth()
  const [showIntro, setShowIntro] = useState(false)

  useEffect(() => {
    Preferences.get({ key: INTRO_KEY })
      .then((r) => setShowIntro(r.value !== '1'))
      .catch(() => setShowIntro(false))
  }, [])

  function dismissIntro() {
    setShowIntro(false)
    void Preferences.set({ key: INTRO_KEY, value: '1' }).catch(() => undefined)
  }

  return (
    <div className={styles.page}>
      <h1 className={styles.welcome}>
        {user?.display_name ? `Welcome back, ${user.display_name}` : 'Home'}
      </h1>

      {showIntro && (
        <section className={styles.intro} aria-label="What is what">
          <p className={styles.introTitle}>Three areas, one app</p>
          <ul className={styles.introList}>
            {FLAVOR.hasNaforo && <li><strong>Naforo</strong> — your bank accounts and spending</li>}
            {FLAVOR.hasYiriba && <li><strong>Yiriba</strong> — your investments (ETF and crypto)</li>}
            <li><strong>Kelen</strong> — this hub: profile, security and settings</li>
          </ul>
          <button type="button" className={styles.introBtn} onClick={dismissIntro}>Got it</button>
        </section>
      )}

      <nav className={styles.sections}>
        {FLAVOR.hasNaforo && (
        <Link to="/accounts" className={styles.sectionCard}>
          <div className={styles.sectionIcon} style={{ color: 'var(--color-pazuru-accent)' }}>
            <Wallet size={24} strokeWidth={1.75} />
          </div>
          <div>
            <div className={styles.sectionTitle}>Naforo</div>
            <div className={styles.sectionDesc}>Bank accounts and transactions</div>
          </div>
        </Link>
        )}

        {FLAVOR.hasYiriba && (
        <Link to="/portfolio" className={styles.sectionCard}>
          <div className={styles.sectionIcon} style={{ color: 'var(--color-tsumi-accent)' }}>
            <TrendingUp size={24} strokeWidth={1.75} />
          </div>
          <div>
            <div className={styles.sectionTitle}>Yiriba</div>
            <div className={styles.sectionDesc}>ETF, crypto and market analysis</div>
          </div>
        </Link>
        )}

        <Link to="/foroba" className={styles.sectionCard}>
          <div className={styles.sectionIcon} style={{ color: 'var(--color-accent)' }}>
            <User size={24} strokeWidth={1.75} />
          </div>
          <div>
            <div className={styles.sectionTitle}>Kelen</div>
            <div className={styles.sectionDesc}>Household, security and settings</div>
          </div>
        </Link>

        {FLAVOR.hasNaforo && (
        <Link to="/import" className={styles.sectionCard}>
          <div className={styles.sectionIcon} style={{ color: 'var(--color-text-secondary, #94a3b8)' }}>
            <Upload size={24} strokeWidth={1.75} />
          </div>
          <div>
            <div className={styles.sectionTitle}>Import Statement</div>
            <div className={styles.sectionDesc}>Pick a CSV or PDF to import transactions</div>
          </div>
        </Link>
        )}
      </nav>
    </div>
  )
}
